export default {
	api: {
		dev: 'https://phd-erp-master.test.flaire.nl/api',
		production: 'https://erp.plafondhogedeur.nl/api'
	},
	render: {
		width: 2000,
		height: 1715
	},
	chat: {
		key: '26byrSSRejAP7LafYT7WiEQ7vjVsb9ff3xb2Xf4aEcAey5HJP6oCMIVi79IP'
	}
};